import { render, staticRenderFns } from "./SNavBar.vue?vue&type=template&id=3aabf1da"
import script from "./SNavBar.vue?vue&type=script&lang=js"
export * from "./SNavBar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports